import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo, useCallback, useReducer, useState, useRef, useEffect } from 'react';
import { createUseStyles, Modal, Text } from 'hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import { intercomHideAndShow } from "../../utils/custom";
import { ENTITIES, MAX_IMPORT_COLUMNS, MAX_IMPORT_ROWS, MAX_IMPORT_COLUMNS_PARAM } from "../../lib/constants";
import { ENTITIES_DATA } from "./constants";
import ImportsLists from "./ImportsLists";
import ImportStepper from "./ImportStepper";
import ExportModal from "./ExportModal";
import ImportedModal from "./ImportedModal";
import ImportContext from "./ImportContext";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'AvoidDuplicates');
const reducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_IMPORT':
      state = _objectSpread(_objectSpread({}, state), {}, {
        activeView: action.view,
        activeImport: action.activeImport
      });
      return state;
    case 'CHANGE_TAB':
      state = _objectSpread(_objectSpread({}, state), {}, {
        activeTab: action.tab,
        activeShrinkedTab: null
      });
      return state;
    case 'CHANGE_SHRINKED_TAB':
      state = _objectSpread(_objectSpread({}, state), {}, {
        activeTab: null,
        activeShrinkedTab: action.value
      });
      return state;
    case 'ON_FINISH':
      return _objectSpread(_objectSpread({}, state), {}, {
        activeView: 'lists',
        activeImport: null,
        modalFinishIsOpen: true,
        isEdit: false
      });
    case 'CLOSE_MODAL_FINISH':
      return _objectSpread(_objectSpread({}, state), {}, {
        modalFinishIsOpen: false,
        entityName: null
      });
    case 'CHANGE_MATCH_BY':
      return _objectSpread(_objectSpread({}, state), {}, {
        matchBy: action.matchBy
      });
    case 'CHANGE_ADVANCED_TYPE':
      return _objectSpread(_objectSpread({}, state), {}, {
        advancedType: action.advancedType
      });
    case 'SET_IS_EDIT':
      return _objectSpread(_objectSpread({}, state), {}, {
        isEdit: action.isEdit
      });
    case 'RESET_IS_EDIT':
      return _objectSpread(_objectSpread({}, state), {}, {
        isEdit: false
      });
    default:
      return state;
  }
};
const initialState = {
  activeTab: ENTITIES.ACCOUNTS.importExport,
  activeView: 'lists',
  // lists | import // FIXME
  activeImport: null,
  modalFinishIsOpen: false,
  matchBy: '',
  advancedType: null,
  isEdit: false
};
const Imports = _ref => {
  var _contextOverrides$per, _contextOverrides$per2;
  let {
    entityLogName = 'import',
    idSetupRole,
    imgImportsName,
    imgImportsFmId,
    imgImportsExtId,
    isNotAdmin,
    contextOverrides,
    activeTab: activeTabProp,
    maxImportColumns = MAX_IMPORT_COLUMNS,
    maxImportRows = MAX_IMPORT_ROWS
  } = _ref;
  const classes = useStyles();
  const {
    t,
    logEvent
  } = useWeb5Context();
  const ExportModalRef = useRef();
  const ImportedModalRef = useRef();
  const isFirstRender = useRef(true);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [activeRowId, setActiveRowId] = useState(null);
  const importLimit = contextOverrides === null || contextOverrides === void 0 ? void 0 : (_contextOverrides$per = contextOverrides.permissions) === null || _contextOverrides$per === void 0 ? void 0 : (_contextOverrides$per2 = _contextOverrides$per.importExport) === null || _contextOverrides$per2 === void 0 ? void 0 : _contextOverrides$per2.importLimit;
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (activeTabProp) {
        dispatch({
          type: 'CHANGE_TAB',
          tab: activeTabProp
        });
      }
      logEvent({
        event: entityLogName,
        submodule: activeTabProp || state.activeTab,
        functionality: 'listView'
      });
    }
  }, [entityLogName, logEvent, state.activeTab, activeTabProp]);
  const onChangeView = useCallback((view, activeImport) => {
    // Compatibility between creation and edition
    intercomHideAndShow('hide');
    let item = activeImport;
    if (item) item.file = {
      name: item.name
    };
    return dispatch({
      type: 'CHANGE_IMPORT',
      view,
      activeImport: item
    });
  }, [dispatch]);
  const onChangeTab = useCallback(tab => {
    logEvent({
      event: entityLogName,
      submodule: tab,
      functionality: 'listView'
    });
    dispatch({
      type: 'CHANGE_TAB',
      tab
    });
  }, [entityLogName, logEvent]);
  const onChangeShrinked = useCallback(value => {
    logEvent({
      event: entityLogName,
      submodule: 'otherTables',
      functionality: 'listView'
    });
    dispatch({
      type: 'CHANGE_SHRINKED_TAB',
      value
    });
  }, [entityLogName, logEvent]);
  const onCancelImport = useCallback(id => {
    let action = {
      type: 'CHANGE_IMPORT',
      view: 'lists',
      activeImport: null
    };
    dispatch(action);
    dispatch({
      type: 'RESET_IS_EDIT'
    });
  }, [dispatch]);
  const setIsEdit = useCallback(() => {
    dispatch({
      type: 'SET_IS_EDIT',
      isEdit: true
    });
  }, []);
  const onChangeMatchBy = useCallback(value => {
    dispatch({
      type: 'CHANGE_MATCH_BY',
      matchBy: value
    });
  }, []);
  const onChangeAdvancedType = useCallback(value => {
    dispatch({
      type: 'CHANGE_ADVANCED_TYPE',
      advancedType: value
    });
  }, []);
  const onExport = useCallback((entity, importType, withData, syncNames) => {
    ExportModalRef.current.open(entity, importType, withData, syncNames);
  }, []);
  const onImported = useCallback(id => {
    setActiveRowId(id);
    dispatch({
      type: 'ON_FINISH'
    });
  }, []);
  const onShowErrors = useCallback(data => ImportedModalRef.current.open(data), []);
  const onConfirmModalFinish = useCallback(() => dispatch({
    type: 'CLOSE_MODAL_FINISH'
  }), []);
  const entityName = useMemo(() => state.activeTab || (state.activeShrinkedTab ? state.activeShrinkedTab.value : null), [state.activeShrinkedTab, state.activeTab]);
  const entityLabelValue = useMemo(() => state.activeTab || (state.activeShrinkedTab ? state.activeShrinkedTab.description : null), [state.activeShrinkedTab, state.activeTab]);
  const entityLabel = useMemo(() => {
    var _ENTITIES_DATA$entity;
    return t((_ENTITIES_DATA$entity = ENTITIES_DATA[entityName]) === null || _ENTITIES_DATA$entity === void 0 ? void 0 : _ENTITIES_DATA$entity.literal) || entityLabelValue;
  }, [entityName, entityLabelValue, t]);
  return /*#__PURE__*/React.createElement(ImportContext.Provider, {
    value: contextOverrides || {}
  }, state && /*#__PURE__*/React.createElement(ImportsLists, {
    entityLogName: entityLogName,
    entityName: entityName,
    onChangeView: onChangeView,
    onChangeTab: onChangeTab,
    onChangeShrinked: onChangeShrinked,
    activeShrinkedTab: state.activeShrinkedTab,
    activeTab: state.activeTab,
    onExport: onExport,
    onShowErrors: onShowErrors,
    idSetupRole: idSetupRole,
    activeRowId: activeRowId,
    setActiveRowId: setActiveRowId,
    isNotAdmin: isNotAdmin,
    setIsEdit: setIsEdit
  }), (state === null || state === void 0 ? void 0 : state.activeView) === 'import' && /*#__PURE__*/React.createElement(ImportStepper, {
    entityLabel: entityLabel,
    entityName: entityName,
    entityLogName: entityLogName,
    item: state.activeImport,
    onCancel: onCancelImport,
    onExport: onExport,
    onImported: onImported,
    shrinkedTab: (state === null || state === void 0 ? void 0 : state.activeShrinkedTab) || null,
    maxImportColumns: importLimit ? maxImportColumns : MAX_IMPORT_COLUMNS_PARAM,
    maxImportRows: importLimit ? maxImportRows : MAX_IMPORT_ROWS,
    matchBy: state.matchBy,
    onChangeMatchBy: onChangeMatchBy,
    advancedType: state.advancedType,
    onChangeAdvancedType: onChangeAdvancedType,
    imgImportsName: imgImportsName,
    imgImportsFmId: imgImportsFmId,
    imgImportsExtId: imgImportsExtId,
    isEdit: state.isEdit,
    idSetupRole: idSetupRole
  }), /*#__PURE__*/React.createElement(ExportModal, {
    entityLogName: entityLogName,
    maxImportColumns: importLimit ? maxImportColumns : MAX_IMPORT_COLUMNS_PARAM,
    maxImportRows: importLimit ? maxImportRows : MAX_IMPORT_ROWS,
    shrinkedTab: (state === null || state === void 0 ? void 0 : state.activeShrinkedTab) || null,
    onRef: ref => ExportModalRef.current = ref,
    matchBy: state.matchBy
  }), /*#__PURE__*/React.createElement(ImportedModal, {
    activeRowId: activeRowId,
    setActiveRowId: setActiveRowId,
    onRef: ref => ImportedModalRef.current = ref
  }), /*#__PURE__*/React.createElement(Modal, {
    title: t('cfm_label_import_in_progress'),
    size: "small",
    isOpen: state.modalFinishIsOpen,
    useCornerClose: false,
    onConfirm: onConfirmModalFinish,
    confirmText: t('action_understood'),
    className: classes.modalFinish,
    classes: {
      header: classes.finishHeader,
      footer: classes.finishFooter
    }
  }, /*#__PURE__*/React.createElement(Text, null, t('cfm_label_import_in_progress_desc'))));
};
process.env.NODE_ENV !== "production" ? Imports.propTypes = {} : void 0;
export default /*#__PURE__*/memo(Imports);